import CustomCard from "../CustomCard";
import React from "react";
import CardForm from "../form/CardForm";
import {fields} from "./AddSummaryFormConfig";
import {Alert} from "react-bootstrap";
import {getUser} from "../../helpers/jwt";
import { useTranslation } from 'react-i18next';

export function Summary(props) {
    const { t } = useTranslation();
    
    function calculateMaxLength() {
        return 2000 - (props.summary?.length || 0) - getUser().length - 40;
    }

    return <>
        <CustomCard
            title={props.title ||
                <>
                    <div className="d-flex align-items-center justify-content-between">
                        <span>{`${t("misc.summary")} (${props.summary ? props.summary.split(props.separator || ";").length : 0})`}</span>
                        {props.summary && <Alert variant={"primary"} className={"mb-0"}>
                            {t("summary.order_placed_for_missing_fonts")}
                        </Alert>
                        }
                    </div>
                </>

            }
            width={props.width || 6}
            shadow={props.shadow !== false}
        >
            {props.summary ?

                <>
                    <div style={{
                        height: props.height || "143px",
                        overflow: "auto",
                        resize: "vertical",
                        border: "1px solid #ccc",
                        padding: "10px"
                    }}>

                        <ul className={""}>
                            {props.summary.split(props.separator || ";").map((s, index) => <p key={index}>{s}</p>)}
                        </ul>

                    </div>
                </>
                : props.emptyLabel || t("common.no_comments")}


        </CustomCard>
        {props.creation &&
            <CardForm
                width={12}
                setLoader={props.setLoader}
                shadow={true}
                readOnly={calculateMaxLength() <= 0}
                withoutHeader={true}
                fields={fields(calculateMaxLength())}
                withoutCancel={true}
                saveButton={t("common.add")}
                customSave={(data, onSaved) => props.create(data.note, onSaved)}
            />
        }
    </>;
}